export default __webpack_public_path__ + "static/media/our-service-accounting-and-finance-content.ced7ca10.jpg";